module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-undo-approval-3d3d989940f9150f9527c89ace6af3cc.svg";